// @flow

import React from 'react'
import { StaticImage } from 'gatsby-plugin-image'
import { useIntl } from 'gatsby-plugin-intl'
import { FormattedMessageSanitized } from '../../FormattedMessageSanitized'
import { applyStylingHoc, type StyleOuterProps, type StyleProps } from '@fcse/tsbob/dist/lib/styling'
import { Container } from '../../../components/basic/Grid'
import SubpageHeroTeaser from '../../../components/SubpageHeroTeaser'
import Contacts from './../Contacts'

/* eslint-disable max-len */
const imageDesktop = (
  <StaticImage
    src="../../../images/heroteaser/imprint_heroteaser_bg_desktop.jpg"
    alt=""
    objectFit="cover"
    className="image"
  />
)
const imprintImage = (
  <StaticImage src="../../../images/pictures/imprint_image.jpg" alt="" objectFit="contain" className="image" />
)
/* eslint-enable max-len */

import messages from './ImprintPage.lang'
import baseStyles from './ImprintPage.scss'

type Props = {
  ...StyleProps
}

const ImprintPage = ({ styles }: Props) => {
  const { formatMessage } = useIntl()

  return (
    <div className={styles.root}>
      <SubpageHeroTeaser title={formatMessage(messages.pageTitle)} image={imageDesktop} imgAlt="office gallery" />
      <Container fluid>
        <Contacts />
        <h2 className={styles.subtitle}>{formatMessage(messages.infoTitle)}</h2>
        <div className={styles.text}>
          <FormattedMessageSanitized tagName="div" {...messages.info} />
        </div>
        <div className={styles.img}>{imprintImage}</div>
      </Container>
    </div>
  )
}

export default applyStylingHoc(baseStyles)<$Diff<Props, StyleProps> & StyleOuterProps, Function>(ImprintPage)
